import React, { useEffect, useState } from "react";
import { FaChartBar } from "react-icons/fa";
import { X, Pencil, Check, Send } from "lucide-react";
import NewPoll from "./components/NewPoll";
import PublishedPoll from "./components/PublishedPoll";
import { CIVIL_CASE_DIRECTOR_ROLE } from "app/utils/const";
import { useAppContext } from "app/contexts/AppContext";
import { useTranslation } from "react-i18next";

const PollsTab = ({ isDirectorOrHead }) => {
    const { t } = useTranslation();
    const { selectedPanel, setSelectedPanel } = useAppContext()
    const [mode, setMode] = useState("published");

    useEffect(() => {
        if (!selectedPanel?.uu_id) return;
        const fetchPolls = async () => {
            try {
                // Fetch poll data logic
            } catch (error) {
                console.error("Error fetching polls:", error);
            }
        };
        fetchPolls();
    }, [selectedPanel?.uu_id]);

    return (
        <div className="relative flex flex-col h-[70vh]">
            {selectedPanel && (
                <div className="flex-1 p-4 bg-gray-50 overflow-y-auto">
                    {isDirectorOrHead && !selectedPanel?.closed && ( ///ZONAL
                        <div className="border-b pb-2 mb-3 flex justify-between items-center">
                            <h3 className="text-[22] font-semibold flex items-center space-x-2"></h3>
                            <button
                                onClick={() => setMode(mode === "published" ? "new" : "published")}
                                className="text-[22] font-semibold"
                            >
                                {mode === "published" ? (
                                    <span style={{ color: "#AAAAAA" }}>{t("Add New")}</span>
                                ) : (
                                    <span style={{ color: "#AAAAAA" }}>{t("View Published")}</span>
                                )}
                            </button>
                        </div>
                    )}
                    {/* new poll */}
                    {mode === 'new' && (
                        <NewPoll selectedPanel={selectedPanel} />
                    )}
                    {mode === 'published' && (
                        <PublishedPoll selectedPanel={selectedPanel} />
                    )}
                </div>
            )}
        </div>
    );
};

export default PollsTab;